
import MarkdownIt from 'markdown-it';
import MarkDownTablePlugin from 'markdown-it-multimd-table';
import MarkDownAnchorPlugin from "markdown-it-anchor"
import MarkDownTocPlugin from "markdown-it-toc-done-right"

const mdParser = new MarkdownIt()
.use(MarkDownAnchorPlugin, { level: 1, permalink: false, permalinkBefore: true, permalinkSymbol: '§' } )
.use(MarkDownTocPlugin)
.use(MarkDownTablePlugin, {
  multiline: false,
  rowspan: true,
  headerless: true,
})

class MdParser {
  static parse (input) {
    return mdParser.render(input)
  }
}

export default MdParser